import AddDocumentModalContainer from 'components/AddDocumentModal/AddDocumentModalContainer'

export default {
  Container: AddDocumentModalContainer,
}
